import * as RegistrationActionTypes from 'actiontypes/registration';

import { bootstrap } from 'actions/app';

import RegisterService from 'services/RegisterService';

/** ----------------------------------------------------------------------------
 * SIGN UP
 -----------------------------------------------------------------------------*/
export default signUp(new RegisterService());

export function signUp(service) {
  return signupData => async (dispatch) => {
    dispatch(signUpRequested());

    try {
      const { data } = await service.emailRegister(signupData);
      // Dispatch an action to let the Redux store know what's up
      dispatch(signUpSuccess(data));
      if (data.isSuccess && data.hasCharacter) {
        // Cool, we should now be logged in, so bootstrap the app state
        dispatch(bootstrap());
      }
      // Return the data (for callers that need to inspect it)
      return data;
    } catch (error) {
      dispatch(signUpFailure(error));
    }
  };
}

export const signUpRequested = () => ({
  type: RegistrationActionTypes.SIGNUP_REQUESTED,
});

export const signUpSuccess = data => ({
  type: RegistrationActionTypes.SIGNUP_SUCCESS,
  payload: data,
});

export const signUpFailure = error => ({
  type: RegistrationActionTypes.SIGNUP_FAILURE,
  status: error.response && error.response.status,
});